import { SITE_UID } from "../assets/meta/meta";
import { KAKAO_CHANNEL_PUBLIC_ID, REDIRECT_URI, REST_API_KEY } from "../common/social/kakao/api";

// 결정 459(B): 손님 로그인은 브라우저 세션 동안만 — 닫았다 다시 열면 카카오 로그인부터(기기 기억·자동 로그인 없음)
const SESSION_KEYS = ["access_token", "refresh_token", "kakao_access_token"];
SESSION_KEYS.forEach((k) => {
  try {
    window.localStorage.removeItem(k);
  } catch {
    // 저장소를 못 쓰는 브라우저는 그대로
  }
});

function readSession(key: string): string | null {
  try {
    return window.sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

function writeSession(key: string, value: string): void {
  try {
    window.sessionStorage.setItem(key, value);
  } catch {
    // 저장소를 못 쓰는 브라우저는 로그인이 화면을 떠나면 끝남
  }
}

export function isUserLogin(): boolean {
  const token = readSession("access_token");
  return Boolean(token);
}

export function setAccessToken(token: string): void {
  if (token) writeSession("access_token", token);
}

export function getAccessToken(): string | null {
  return readSession("access_token");
}

export function removeAccessToken(): void {
  writeSession("access_token", "");
}

export function setRefreshToken(token: string): void {
  if (token) writeSession("refresh_token", token);
}

export function getRefreshToken(): string | null {
  return readSession("refresh_token");
}

export function removeRefreshToken(): void {
  writeSession("refresh_token", "");
}

const DEVICE_ID_KEY = "amazing_web_device_id";

export function getDeviceId(): string {
  const stored = window.localStorage.getItem(DEVICE_ID_KEY);
  if (stored) return stored;
  const generated =
    typeof crypto !== "undefined" && "randomUUID" in crypto
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  window.localStorage.setItem(DEVICE_ID_KEY, generated);
  return generated;
}

export function getDeviceName(): string {
  return navigator.userAgent || "Web";
}

export function setKakaoAccessToken(token: string): void {
  if (token) writeSession("kakao_access_token", token);
}

export function getKakaoAccessToken(): string | null {
  return readSession("kakao_access_token");
}

export function removeKakaoAccessToken(): void {
  writeSession("kakao_access_token", "");
}

// 카카오톡 기본 동의항목: profile, phone_number, plusfriends
export const KAKAO_AUTH_URL = `https://kauth.kakao.com/oauth/authorize?client_id=${REST_API_KEY}&redirect_uri=${REDIRECT_URI}&response_type=code&state=${SITE_UID}${KAKAO_CHANNEL_PUBLIC_ID ? `&channel_public_id=${encodeURIComponent(KAKAO_CHANNEL_PUBLIC_ID)}` : ""}`;

